import styled from 'styled-components'
import { UseCases } from '../../../constants/useCases.constants'

export const StyledGrid = styled.div<{ $useCase?: string; $rowMax?: string }>`
  ${({ theme, $useCase, $rowMax }: any) => {
    let alignment = 'space-between'
    let widthOfChild = 100 / parseInt($rowMax)

    if ($useCase === UseCases.GRID_RIGHT_ALIGNED) {
      alignment = 'flex-end'
    } else if ($useCase === UseCases.GRID_LEFT_ALIGNED) {
      alignment = 'flex-start'
    } else if ($useCase === UseCases.GRID_CENTERED) {
      alignment = 'center'
    }

    return `
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: ${alignment};
      max-width: 1224px;
      margin: 0 auto -24px auto;
      box-sizing: border-box;
      align-items: center;
      box-sizing: border-box;

      ${theme.breakpoints.down('md')} {
        max-width: 984px;
      }

      ${theme.breakpoints.down('sm')} {
        max-width: 752px;
        margin: 0 auto -16px auto;
        justify-content: center;
      }

      ${LogoContainer} {
        width: ${$rowMax === 'None' ? 'unset' : `calc(${widthOfChild}% - 24px)`};
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        flex-direction: row;
        align-items: center;
        margin: 0 12px 24px 12px;

        ${theme.breakpoints.down('sm')} {
          width: ${$rowMax === 'None' ? 'unset' : `calc(${widthOfChild}% - 16px)`};
          margin: 0 8px 24px 8px;
        }

        ${theme.breakpoints.down('xs')} {
          width: calc(50% - 16px);
          margin: 0 8px 16px 8px;
        }

        img {
          width: 100%;
          height: auto;
          max-height: 100%;
          object-fit: cover;
        }

        &.Grid__Item--LG {
          height: 192px;

          ${theme.breakpoints.down('md')} {
            height 152px;
          }

          img {
            width: 384px;
            ${theme.breakpoints.down('md')} {
              width: 304px;
            }
          }
        }

        &.Grid__Item--MD {
          height: 141px;
          ${theme.breakpoints.down('md')} {
            height 111px;
          }

          img {
            width: 282px;
            ${theme.breakpoints.down('md')} {
              width: 222px;
            }
          }
        }

        &.Grid__Item--SM {
          height: 90px;
          ${theme.breakpoints.down('md')} {
            height 70px;
          }

          img {
            width: 180px;
            ${theme.breakpoints.down('md')} {
              width: 140px;
            }
          }
        }

        &.Grid__Item--LG,&.Grid__Item--MD,&.Grid__Item--SM {
          ${theme.breakpoints.down('sm')} {
            height: 86px;
          }

          ${theme.breakpoints.down('xs')} {
            height: 78px;
          }

          img {
            ${theme.breakpoints.down('sm')} {
              width: 172px;
            }

            ${theme.breakpoints.down('xs')} {
              width: 156px;
            }
          }
        }
      }
        &.fullWidth__useCase {
       padding: 0 40px;
       max-width: 100%;
       row-gap: 48px;

      ${theme.breakpoints.down('md')} {
        row-gap: 48px;
        margin-bottom: 0;
      }

      ${theme.breakpoints.down('xs')} {
        row-gap: 0;
      }
      .fullWidth__useCase--img {
        border-right: 1px solid ${theme.webMktPalette.grayNeutral[45]};
        flex: 1;
        margin-left: 0;
        margin-right: 0;
        min-width: 192px;
        height: 96px;
        ${theme.breakpoints.down('md')} {
          width: 33%;
          flex:auto;
           &:nth-child(3n) {
            border-right: 0;
          }
        }
        ${theme.breakpoints.down('sm')} {
          width: 50%;
		      &:nth-child(even) {
            border-right: 0;
          }
          &:nth-child(3) {
            border-right: 1px solid ${theme.webMktPalette.grayNeutral[45]};
          }
        }
        ${theme.breakpoints.down('xs')} {
          width: 100%;
          border-right: 0;
          padding: 48px 0;
          height: auto !important;
          margin: 0;
          border-bottom: 1px solid ${theme.webMktPalette.grayNeutral[45]};
    
          &:nth-child(3) {
            border-right: 0;
          }
        }
        &:last-child {
          border-bottom: 0;
          padding-bottom: 0;
          border-right:0;
        }
        img {
          width: auto;
          height: 96px;

          ${theme.breakpoints.down('md')} {
            width: auto;
            height: 96px;
          }
        }
      }      
    }
    `
  }}
`

export const GridOuter = styled.div<{
  $gridContainerTheme?: string
  $topPadding?: string
  $bottomPadding?: string
  $isHomePage?: boolean
}>`
  ${({ theme, $gridContainerTheme, $topPadding, $bottomPadding, $isHomePage }) => {
    let paddingBottom, paddingTop, itemBg
    let largePadding = '96px'
    let smallPadding = '64px'
    let noPadding = '0'

    if ($bottomPadding === 'Large') {
      paddingBottom = largePadding
    } else if ($bottomPadding === 'None') {
      paddingBottom = noPadding
    } else if ($bottomPadding === 'Small') {
      paddingBottom = smallPadding
    }

    if ($topPadding === 'Large') {
      paddingTop = largePadding
    } else if ($topPadding === 'None') {
      paddingTop = noPadding
    } else if ($topPadding === 'Small') {
      paddingTop = smallPadding
    }

    if ($isHomePage) {
      itemBg = ``
    }

    return `
      padding-bottom: ${paddingBottom};
      padding-top: ${paddingTop};
      background: ${
        $gridContainerTheme === 'Light'
          ? theme.webMktPalette.background.white
          : theme.webMktPalette.background.gray
      };

      ${theme.breakpoints.down('sm')} {
        padding-bottom: 64px;
      }
      
      @media (max-width: 767px) {
        padding-bottom: 48px;
      }
      
      ${StyledGrid} {
        ${itemBg}
      }
    `
  }}
`

export const LogoContainer = styled.div``

export const SponsorsLogoGrid = styled.div`
  max-width: 1652px;
  margin: 0 auto;
  padding: 0 62px;

  ${({ theme }) => theme.breakpoints.down('xl')} {
    padding: 0 16px;
  }

  ${({ theme }) => theme.breakpoints.down('lg')} {
    padding: 0 32px;
  }

  ${({ theme }) => theme.breakpoints.down('xs')} {
    padding: 0 24px;
  }

  @media (max-width: 767px) {
    padding: 0 16px;
  }

  h3 {
    text-align: center;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 32px;
    margin-bottom: 64px;

    ${({ theme }) => theme.breakpoints.down('lg')} {
      margin-bottom: 48px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      font-size: 22px;
      line-height: 28px;
      font-weight: 700;
      letter-spacing: 0px;
    }

    @media (max-width: 767px) {
      margin-bottom: 32px;
    }

    &::before,
    &::after {
      content: '';
      flex-grow: 1;
      height: 1px;
      background-color: ${({ theme }) => theme.webMktPalette.grayNeutral[35]};
    }
  }
`
export const LogosList = styled.div<{ $sponsor?: string; $rowMax?: string }>`
  ${({ theme, $sponsor, $rowMax }: any) => {
    let logoImgStyling = ''
    let logoListStyling = ''

    if ($sponsor === 'Diamond') {
      logoListStyling = `
        width: calc(33.333% - 103px); 
        padding: 0px 77px;

        &:nth-child(3n+1) {
          padding-left: 0;
        }
        &:nth-child(3n) {
          padding-right: 0;

          &::after {
            display: none;
          }
        }

        
        

        ${theme.breakpoints.down('lg')} {
          width: calc(33.333% - 48px);
          padding: 0 36px;
        }
        ${theme.breakpoints.down('xs')} { 
          width: calc(50% - 60px);
          padding: 0 60px;

          &:nth-child(3n+1) {
            padding-left: 60px;
          }
          &:nth-child(3n) {
            padding-right: 60px;

            &::after {
              display: block;
            }
          }

          &:nth-child(2n+1) {
            padding-left: 0;
          }
          &:nth-child(2n) {
            padding-right: 0;
            
            &::after {
              display: none;
            }
          }
        }

        @media (max-width: 767px) {
          width: 100%; 
          padding: 0 !important;

          &::after {
            display: none !important;
          }
        }
      `
      logoImgStyling = `
        ${LogoContainer} img {
        max-width: 380px;
        max-height: 190px;
        height: 190px;

        ${theme.breakpoints.down('md')} {
          max-width: 340px;
          max-height: 170px;
          height: 170px;
        }
        ${theme.breakpoints.down('xs')} {
          max-width: 300px;
          max-height: 150px;
          height: 150px;
        }
        @media (max-width: 767px) {
          max-width: 200px;
          max-height: 100px;
          height: 100px;
        }
      }`
    } else if ($sponsor === 'Ruby') {
      logoListStyling = `
        width: calc(25% - 60px);
        padding: 0 40px;

        &:nth-child(4n+1) {
          padding-left: 0;          
        }
        &:nth-child(4n) {
          padding-right: 0;
          &::after {
            display: none;
          }
        }

        ${theme.breakpoints.down('lg')} {
          width: calc(25% - 24px);
          padding: 0 16px;
        }
        ${theme.breakpoints.down('xs')} {
          width: calc(33.333% - 20px);
          padding: 0 15px;

          &:nth-child(4n+1) {
            padding-left: 15px;          
          }
          &:nth-child(4n) {
            padding-right: 15px;
            &::after {
              display: block;
            }
          }

          &:nth-child(3n+1) {
            padding-left: 0;
          }
          &:nth-child(3n) {
            padding-right: 0;
            &::after {
              display: none;
            }
          }
        }

        @media (max-width: 767px) {
          width: calc(50% - 14px); 
          padding: 0 14px;

          &:nth-child(3n+1) {
            padding-left: 14px;
          }
          &:nth-child(3n) {
            padding-right: 14px;
            &::after {
              display: block;
            }
          }
            
          &:nth-child(2n+1) {
            padding-left: 0;
          }
          &:nth-child(2n) {
            padding-right: 0;
            &::after {
              display: block;
            }
          }

          &:nth-child(2n + 2) {
            &::after {
              display: none;
            }
          }
        }

      `
      logoImgStyling = `
        ${LogoContainer} img {
        max-width: 320px;
        max-height: 160px;
        height: 160px;

        ${theme.breakpoints.down('md')} {
          max-width: 280px;
          max-height: 140px;
          height: 140px;
        }
        ${theme.breakpoints.down('xs')} {
          max-width: 220px;
          max-height: 110px;
          height: 110px;
        }
        @media (max-width: 767px) {
          max-width: 150px;
          max-height: 75px;
          height: 75px;
        }
      }`
    } else if ($sponsor === 'Emerald') {
      logoListStyling = `
        width: calc(20% - 42px);
        padding: 0 26px;
        
        &:nth-child(5n+1) {
          padding-left: 0;
        }
        &:nth-child(5n) {
          padding-right: 0;
          &::after {
              display: none;
            }
        }

        ${theme.breakpoints.down('lg')} {
          width: calc(20% - 24px);
          padding: 0 15px;
        }
        ${theme.breakpoints.down('xs')} {
          width: calc(25% - 23px);
          padding: 0 15px;          
          
          &:nth-child(5n+1) {
            padding-left: 15px;
          }
          &:nth-child(5n) {
            padding-right: 15px;
            &::after {
                display: block;
              }
          }

          &:nth-child(4n+1) {
            padding-left: 0;
            &::after {
              display: block;
            }
          }
          &:nth-child(4n) {
            padding-right: 0;
            &::after {
              display: none;
            }
          }
        }

        @media (max-width: 767px) {
          width: 33.333%; 
          padding: 0 !important;
          margin: 12px 0;
          
          &::before {
            bottom: -12px;
          }
          
          &:nth-child(4n) {
            &::after {
              display: block;
            }
          }

          &:nth-child(3n+1) {
            padding-left: 0;
          }
          &:nth-child(3n) {
            padding-right: 0;
          }
          
          &:nth-child(3n + 3) {
            &::after {
              display: none;
            }
          }
          &:last-child {
            &::after {
              display: none;
            }
          }
        }
      `
      logoImgStyling = `
        ${LogoContainer} img {
        max-width: 280px;
        max-height: 140px;
        height: 140px;

        ${theme.breakpoints.down('lg')} {
          max-width: 220px;
          max-height: 110px;
          height: 110px;
        }
        ${theme.breakpoints.down('xs')} {
          max-width: 180px;
          max-height: 90px;
          height: 90px;
          height: 90px;
        }
        @media (max-width: 767px) {
          max-width: 108px;
          max-height: 54px;
          height: 54px;
        }
      }`
    } else if ($sponsor === 'Sapphire') {
      logoListStyling = `
        width: calc(16.666% - 35px);
        padding: 0 21px; 
        
        &:nth-child(6n+1) {
          padding-left: 0;          
        }
        &:nth-child(6n) {
          padding-right: 0;
          &::after {
              display: none;
            }
        }

        ${theme.breakpoints.down('lg')} { 
          width: calc(16.666% - 7px);
          padding: 0 4px;
        }
        ${theme.breakpoints.down('xs')} {
          width: calc(25% - 23px);
          padding: 15px;          
          
          &:nth-child(6n+1) {
            padding-left: 15px;          
          }
          &:nth-child(6n) {
            padding-right: 15px;
            &::after {
                display: none;
              }
          }
          
          &:nth-child(4n) {
            padding-right: 0;
            &::after {
              display: none;
            }
          }

          &:nth-child(4n+1) {
            padding-left: 0;
          }
          &:nth-child(4n + 2) {
            &::after {
              display: block;
            }
          }
        }

        @media (max-width: 767px) {
          width: 33.333%;
          padding: 0;
          margin: 12px 0;
          &::before {
            bottom: -12px;
          }

          &:nth-child(4n) {
            padding-right: 0;
            &::after {
              display: block;
            }
          }
          &:nth-child(3n) {
            padding-right: 0;
            &::after {
              display: none;
            }
          }

          &:nth-child(3n+1) {
            padding-left: 0;
            &::after {
              display: block;
            }
          }
        }
      `
      logoImgStyling = `
        ${LogoContainer} img {
        max-width: 240px;
        max-height: 120px;
        height: 120px;
        ${theme.breakpoints.down('lg')} {
          max-width: 200px;
          max-height: 100px;
          height: 100px;
        }
        ${theme.breakpoints.down('xs')} {
          max-width: 180px;
          max-height: 90px;
          height: 90px;
        }
        @media (max-width: 767px) {
          max-width: 108px;
          max-height: 54px;
          height: 54px;
        }
      }`
    }

    return `
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      > div {        
        display: flex;        
        justify-content: center;
        align-items: center;
        text-align: center;
        position: relative;
        margin: 24px 0;
        
    
        &::after {
          content: '';
          position: absolute;
          height: 100%;
          width: 1px;
          background-color: ${theme.webMktPalette.grayNeutral[35]};
          right: 0px;
          top: 0px;
        }

        &::before {
          content: '';
          position: absolute;
          height: 1px;
          width: 100%;
          background-color: ${theme.webMktPalette.grayNeutral[35]};
          right: 0px;
          bottom: -24px;
        }     
          
        &.lastRow {
          &::before {
            display: none;
          }
        }

        ${logoListStyling}

        &:last-child {
          padding-right: 0;
          &::after {
            display: none;
          }
        }

        img {
          width: 100%;
          object-fit: contain;
        }
      }

      ${logoImgStyling}
    `
  }}
`
